import React, { useState, useEffect } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import API, { resolvePhoto } from '../../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';
import { CheckCircle, XCircle, ExternalLink } from 'lucide-react';

export default function AdminPayments() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState('');
  const [preview, setPreview] = useState(null);

  const load = () => {
    setLoading(true);
    API.get('/payments/manual/pending')
      .then(r => { setArticles(r.data.articles || []); setLoading(false); })
      .catch(() => { toast.error('Gagal memuat pembayaran'); setLoading(false); });
  };
  useEffect(() => { load(); }, []);

  const verify = async (id, approve) => {
    if (approve === false && !window.confirm('Tolak bukti transfer ini? Reader perlu mengunggah ulang.')) return;
    setBusy(id);
    try {
      const res = await API.patch(`/payments/manual/${id}/verify`, { approve });
      toast.success(approve ? `Diverifikasi. ${res.data.invoiceNumber || ''}` : 'Pembayaran ditolak.');
      setArticles(prev => prev.filter(a => a._id !== id));
    } catch (err) { toast.error(err.response?.data?.message || 'Gagal memproses'); }
    finally { setBusy(''); }
  };

  return (
    <DashboardLayout title="Verifikasi Pembayaran" subtitle="Tinjau bukti transfer manual dari reader & terbitkan invoice">
      {loading ? (
        <div className="ki-card">{[...Array(3)].map((_, i) => <div key={i} className="shimmer" style={{ height: 80, borderRadius: 8, marginBottom: 10 }} />)}</div>
      ) : articles.length === 0 ? (
        <div className="ki-card" style={{ textAlign: 'center', padding: '60px 24px', color: 'var(--ki-text-muted)', fontSize: 14 }}>
          Tidak ada pembayaran menunggu verifikasi.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {articles.map(a => (
            <div key={a._id} className="ki-card" style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
              {a.payment?.proofUrl && (
                <img src={resolvePhoto(a.payment.proofUrl)} alt="bukti" onClick={() => setPreview(resolvePhoto(a.payment.proofUrl))}
                  style={{ width: 90, height: 90, objectFit: 'cover', borderRadius: 8, cursor: 'zoom-in', flexShrink: 0, border: '1px solid var(--ki-border)' }} />
              )}
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>{a.title || a.what}</div>
                <div style={{ fontSize: 13, color: 'var(--ki-text-muted)' }}>Pengaju: {a.requestedBy?.name} · {a.requestedBy?.email}</div>
                <div style={{ fontSize: 13, color: 'var(--ki-text-muted)' }}>Nominal: <strong>Rp {Number(a.payment?.amount || 0).toLocaleString('id-ID')}</strong></div>
                {a.payment?.senderName && <div style={{ fontSize: 12, color: 'var(--ki-text-faint)' }}>Pengirim: {a.payment.senderName}</div>}
                {a.payment?.proofUploadedAt && <div style={{ fontSize: 12, color: 'var(--ki-text-faint)' }}>Diunggah: {format(new Date(a.payment.proofUploadedAt), 'd MMM yyyy, HH.mm', { locale: id })}</div>}
              </div>
              <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                <button className="btn btn-primary btn-sm" disabled={busy === a._id} onClick={() => verify(a._id, true)}>
                  <CheckCircle size={14} /> Verifikasi
                </button>
                <button className="btn btn-sm" disabled={busy === a._id} onClick={() => verify(a._id, false)}
                  style={{ background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', color: '#DC2626' }}>
                  <XCircle size={14} /> Tolak
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {preview && (
        <div onClick={() => setPreview(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, cursor: 'zoom-out' }}>
          <img src={preview} alt="bukti transfer" style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: 8 }} />
        </div>
      )}
    </DashboardLayout>
  );
}
